import asyncComponent from './async-component';

const NoInstanceText = asyncComponent(() => import('./TextComp'));

export default NoInstanceText;



// WEBPACK FOOTER //
// ./src/components/NoInstanceText.js